import "./FeatureInfo.css";
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { useTranslation } from "react-i18next";
import { createTitle, createRecord } from "../../utils/JSXHandler";

import { vector } from "../../_config/layers/";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Dialog } from "primereact/dialog";

const FeatureInfo = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const htmlElement = useRef();

  const [modalValue, setModalValue] = useState("");
  const [active, setActive] = useState(0);
  const [enabled, setEnabled] = useState(false);


  useImperativeHandle(ref, () => ({
    deactivate: () => {
      setEnabled(false);
      window.activeFillModal = false;
    
      if (props.handleActiveTool) {
        props.handleActiveTool(null);
      }
    }
  }));

  const checkQueryableLayers = () => {
    return props.map
      .getLayers()
      .getArray()
      .filter((layer) => layer.getVisible() && layer.get("queryable"));
  };

  const requestFeatureInfo = async (evt, queryableLayers) => {
    let featureInfo = [];
    vector.getSource().clear();

    for (let i = 0; i < queryableLayers.length; i++) {
      const view = props.map.getView();
      const viewResolution = view.getResolution();
      const source = queryableLayers[i].getSource();
      const url = source?.getFeatureInfoUrl(
        evt.coordinate,
        viewResolution,
        view.getProjection(),
        {
          INFO_FORMAT: "application/json",
          FEATURE_COUNT: 50,
        }
      );

      if (url) {
        await fetch(url)
          .then((response) => response.json())
          .then((data) => {
            if (data?.features?.length) {
              featureInfo.push(createTitle(t(queryableLayers[i].get("title"))));
              data.features.forEach((feature, i) => {
                featureInfo.push(createRecord(i, feature.properties));
              });
            }
          })
          .catch((err) => console.error(err));
      }
    }

    return featureInfo;
  };

  useEffect(() => {
    window.activeFillModal = false;

    props.map.on("singleclick", async (evt) => {
      if (window.activeFillModal) {
        vector.getSource().clear();

        const coordinate = evt.coordinate;
        const coordinateInfo = (
          <span key="featureCoordinates">
            <h5>{t("featureInfo.coordinatesTitle")}</h5>
            <span className="FeatureField">
              {t("featureInfo.latitude")}
            </span>: {coordinate[0]},
            <span className="FeatureField"> {t("featureInfo.longitude")}</span>:{" "}
            {coordinate[1]}
          </span>
        );

        const queryableLayers = checkQueryableLayers();
        const featureInfo = await requestFeatureInfo(evt, queryableLayers);

        if (featureInfo.length > 0) {
          setModalValue([
            ...featureInfo,
            <hr key="separator" />,
            coordinateInfo,
          ]);
        }

        setActive((prev) => prev + 1);
      }
    });
  }, [props.map, t]);

  useEffect(() => {
    window.activeFillModal = enabled;
    
    // NOTIFICA O PAI SOBRE A MUDANÇA DE ESTADO
    if (props.handleActiveTool) {
      // Se enabled for true, passa uma referência (qualquer truthy)
      // Se enabled for false, passa null
      props.handleActiveTool(enabled ? htmlElement.current : null);
    }
  }, [enabled, props.handleActiveTool]);

  const handleClick = () => {
    setEnabled((prev) => !prev);
  };

  return (
    <>
      <Button
        alt={t("featureInfo.buttonTooltip")}
        onClick={handleClick}
        className={`FeatureInfoButton FeatureInfo ${
          enabled ? "FeatureInfoActive" : "FeatureInfoDeactive"
        }`}
        ref={htmlElement}
        severity="info"
        icon="pi pi-info-circle"
        rounded
      />

      <Tooltip
        target=".FeatureInfoButton"
        content={t("featureInfo.buttonTooltip")}
        position="bottom"
        className="CustomTooltip"
      />
      
      <Dialog
        className="FeatureInfoDialog"
        header={t("featureInfo.modalTitle")}
        visible={active > 0}
        onHide={() => setActive(0)}
        modal
        appendTo={document.body}
        draggable={false}
        resizable={false}
        style={{ width: "50vw" }}
      >
        {modalValue}
      </Dialog>
    </>
  );
});

FeatureInfo.displayName = 'FeatureInfo';

export default FeatureInfo;